import { LocaleSwitcherCompact } from "#components/locale-switcher-compact"
import { LoginForm } from "#components/login-form"
import { RegisterForm } from "#components/register-form"
import React, { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"

const Login: React.FC = () => {
  const [searchParams] = useSearchParams()
  const invitationToken = searchParams.get("token")
  const [isLogin, setIsLogin] = useState(!invitationToken) // Show register form if token exists

  useEffect(() => {
    // If there's an invitation token, show register form
    if (invitationToken) {
      setIsLogin(false)
    }
  }, [invitationToken])

  const handleSwitchToRegister = () => {
    setIsLogin(false)
  }

  const handleSwitchToLogin = () => {
    setIsLogin(true)
  }

  return (
    <div className="grid min-h-svh lg:grid-cols-2">
      <div className="flex flex-col gap-4">
        <div className="absolute top-4 right-4 z-10">
          <LocaleSwitcherCompact />
        </div>
        <div className="flex flex-1 items-center justify-center bg-muted">
          {isLogin ? (
            <LoginForm onSwitchToRegister={handleSwitchToRegister} />
          ) : (
            <RegisterForm
              onSwitchToLogin={handleSwitchToLogin}
              invitationToken={invitationToken || undefined}
            />
          )}
        </div>
      </div>
      <div className="bg-muted relative hidden lg:block flex items-center justify-center p-8">
        <img
          src="/images/login.svg"
          alt="Image"
          className="h-full w-full object-contain dark:brightness-[0.2] dark:grayscale"
        />
      </div>
    </div>
  )
}

export default Login
